import { useState } from 'react';
import { LEAVE_TYPES, STATUS_LABELS, formatDate } from '../constants';
import { api } from '../api';

export default function ReviewModal({ leave, onClose, onReviewed }) {
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const typeConf = LEAVE_TYPES[leave.type] || LEAVE_TYPES.other;

  const handleDecision = async (status) => {
    setLoading(true);
    setError('');
    try {
      await api.reviewLeave(leave.id, status, note);
      onReviewed(leave.id, status);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <span className="modal-title">Wniosek urlopowy</span>
          <button className="btn btn-ghost" onClick={onClose} style={{ fontSize: 20, padding: '4px 8px' }}>×</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-error">{error}</div>}

          <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 8, padding: 16, marginBottom: 16 }}>
            <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 700, fontSize: 16 }}>{leave.user_name}</span>
              <span className="badge" style={{ background: typeConf.bg, color: typeConf.color }}>{typeConf.label}</span>
            </div>
            <div style={{ fontSize: 15, marginBottom: 4 }}>
              📅 <strong>{formatDate(leave.date_from)}</strong> – <strong>{formatDate(leave.date_to)}</strong>
            </div>
            <div style={{ color: 'var(--text3)', fontSize: 13 }}>
              {leave.days_count} {leave.days_count === 1 ? 'dzień roboczy' : 'dni roboczych'}
            </div>
            {leave.note && (
              <div style={{ marginTop: 10, padding: '8px 10px', background: 'white', borderRadius: 6, border: '1px solid var(--border)', fontSize: 14, color: 'var(--text2)' }}>
                <strong>Uwaga pracownika:</strong> {leave.note}
              </div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Komentarz (opcjonalnie)</label>
            <textarea className="form-input" rows={3} value={note} onChange={e => setNote(e.target.value)} placeholder="Powód decyzji, uwagi..." style={{ resize: 'vertical' }} />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline" onClick={onClose}>Anuluj</button>
          <button className="btn btn-danger" onClick={() => handleDecision('rejected')} disabled={loading}>
            ✕ Odrzuć
          </button>
          <button className="btn btn-primary" onClick={() => handleDecision('approved')} disabled={loading}>
            ✓ Zatwierdź
          </button>
        </div>
      </div>
    </div>
  );
}
